import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {IRangoTiempo} from "../../shared/interfaces/database/configuracion";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RangoTiempoService {
  private readonly baseUrl = `${environment.apiUrl}/api/rango-tiempo`;

  constructor(private http: HttpClient) {
  }

  getAllByControlTiempoId(id: number, version: number): Observable<IRangoTiempo[]> {
    return this.http.get<IRangoTiempo[]>(`${this.baseUrl}/get-by-control/${id}/${version}`);
  }

  crear(body: Omit<IRangoTiempo, 'id'>): Observable<Required<IRangoTiempo>> {
    return this.http.post<Required<IRangoTiempo>>(`${this.baseUrl}/crear`, body);
  }

  modificar(id: number, body: Omit<IRangoTiempo, 'id'>): Observable<Required<IRangoTiempo>> {
    return this.http.put<Required<IRangoTiempo>>(`${this.baseUrl}/modificar/${id}`, body);
  }



}
